import _ from 'lodash';
import React, { Component } from 'react';
import Validator from 'validatorjs';
import { Row, Col, Modal } from 'react-bootstrap';

import * as XLSX from 'xlsx';
import Loading from '../../../../../facturotopia/loading/Loading';
import ResponseError from '../../../../../shared/responses/ResponseError';
import ResponseResult from '../../../../../shared/responses/ResponseResult';

class ComercioExteriorMercanciasUploadFile extends Component {
  state = {};

  constructor(props) {
    super(props);

    this.state = {
      data: {},
      progress: 0,
      validator: new Validator({}, this.rules),
      show: props.show
    };
  }

  get rules() {
    return {
      'data.*.NoIdentificacion': ['required', 'min:1', 'max:100'],
      'data.*.FraccionArancelaria': ['required', 'numeric'],
      'data.*.CantidadAduana': ['min:0.001'],
      'data.*.UnidadAduana': ['string'],
      'data.*.ValorUnitarioAduana': ['numeric'],
      'data.*.ValorDolares': ['required', 'numeric']
    }
  }

  validate(data) {
    const validator = new Validator(data, this.rules);

    validator.check();

    this.setState({
      validator
    });

    return validator;
  }

  handleOnReaderFile = (event) => {
    this.setState({
      progress: 1
    });

    const file = event.target.files[0];
    const fileReader = new FileReader();

    try {
      fileReader.readAsArrayBuffer(file);

      fileReader.onload = (e) => {
        const bufferArray = e.target.result;
        const xlsx = XLSX.read(bufferArray, { type: "buffer" });
        const name = xlsx.SheetNames[0];
        const sheet = xlsx.Sheets[name];
        const data = XLSX.utils.sheet_to_json(sheet);

        const validator = this.validate({ data });
        const isValid = validator.passes();

        if (!!isValid) {
          this.setState({ data: data })

          this.handleOnAdd(data);
        } else {
          let errors = _.map(validator.errors.all(), (error, key) => {
            const fila = key.split('.');

            return _.map(error, (value) => {
              let message = value.replace(`${fila[0]}.${fila[1]}.`, '');
              message = `Fila ${parseInt(fila[1]) + 2}: ` + message;

              return { message: message };
            });
          });

          errors = errors.flat()

          const error = {
            message: 'Error de validación',
            errors: [
              ...errors
            ]
          }

          this.setState({
            showError: true,
            error: error
          });
        }
      }

      event.target.value = null;
    } catch (error) {
      //
    }
  }

  handleOnAdd = (data) => {
    const newData = _.map(data, (item) => {
      item = _.assign(item, {
        NoIdentificacion: !!item.NoIdentificacion ? item.NoIdentificacion.toString() : '',
        FraccionArancelaria: !!item.FraccionArancelaria ? item.FraccionArancelaria.toString() : '',
        ValorUnitarioAduana: !!item.ValorUnitarioAduana ? item.ValorUnitarioAduana.toString() : '',
        ValorDolares: !!item.ValorDolares ? item.ValorDolares.toString() : '',
      });

      return item;
    });

    this.props.onAdd(newData);

    const result = {
      message: `Se agregaron un total de ${ newData.length } mercancías, se mostrarán en la tabla de mercancias.`
    }

    this.setState({
      progress: 100,
      result: result,
      showResult: true
    });
  }

  handleOnAction = () => {
    this.setState({
      showResult: false,
      showError: false
    });

    this.handleOnClose();

    return;
  }

  handleOnClose = () => {
    const data = {
      show: false
    }

    this.props.onClose(data);
  }

  renderResult = () => {
    const { result } = this.state

    return (
      <div className="result-container">
        <ResponseResult
          title="Completado"
          result={ result }
          onAction={ this.handleOnAction }
        />
      </div>
    );
  }

  renderError = () => {
    const { error } = this.state

    return (
      <div className="result-container">
        <ResponseError
          title="Error"
          error={ error }
          onAction={ this.handleOnAction }
        />
      </div>
    );
  }

  render() {
    const { data, progress, showResult, showError, show } = this.state;

    if (progress === 100 && !!showResult) {
      return this.renderResult();
    }

    if (!!showError) {
      return this.renderError();
    }

    return (
      <Modal backdrop="static" keyboard={ false } show={ show } centered={ true } onHide={ this.handleOnClose }>
        <Modal.Header closeButton>
          <Modal.Title>
            Subir archivo
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col>
              <label>
                <input type="file" accept=".csv, .xls, .xlsx" onChange={ this.handleOnReaderFile } />
              </label>

              { (progress > 0 && progress < 100) && !!data && (
                <Row>
                  <Col>
                    <Loading className="mt-3 ml-3" />
                  </Col>
                </Row>
              )}

              <div className="p-3">
                <label>Instrucciones.</label>
                <ul className="list-unstyled">
                  <li>1. <a target="_blank"  href="/resources/template-comercioexterior-mercancias.xlsx">Descarga</a> el template</li>
                  <li>2. Sigue la guía de llenado</li>
                  <li>3. Sube el archivo</li>
                </ul>
              </div>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    )
  }
}

export default ComercioExteriorMercanciasUploadFile;
